import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

import type { TCustomerFormJson } from '../types/client-form-json.type'
import axios from 'axios'

export type TCustomerFormSaveActionService = {
  payload: {
    operationType: string
    customerFormJson: TCustomerFormJson
  }
}

export const customerFormSaveActionService = async ({
  payload,
}: TCustomerFormSaveActionService): Promise<ResponseAPI> => {
  const response = await api.post(
    `salvarcliente/${payload.operationType}`,
    payload.customerFormJson,
  )
  return response.data
}
